export default __webpack_public_path__ + "static/Artistas_Biomateriales_SMALL-1720f4036088502723201cdfa12458b0.jpg";